/* eslint-disable react/button-has-type */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/require-default-props */
import React from "react";
import { Spinner } from "./Loader";
// import './button.css';

/**
 * Buttons allow users to trigger an action or event with a single click. For example, you can use a button for allowing the functionality of submitting a form, opening a dialog, canceling an action, or performing a delete operation.
 */

export type buttonProps = {
  /**
   * Button contents label
   */
  label?: string;
  /**
   * Custom class name to pass to the component
   */
  className?: string;
  /**
   * Button types, varient
   */
  varient?: "primary" | "secondary" | "tertiary";
  /**
   * Custom style to pass to the component
   */
  style?: object;
  /**
   * Whether the button is disabled or not
   */
  disabled?: boolean | any;
  /**
   * Button sizes
   */
  size: "small" | "medium";
  /**
   * Button icon element
   */
  icon?: any;
  /**
   * Add icon on the button
   */
  withIcon?: boolean;
  /**
   * Button loading state
   */
  isLoading?: boolean;
  /**
   * Loader color
   */
  loaderColor?: string;
  /**
   * Loader width in pixels
   */
  loaderWidth?: string;
  /**
   * Loader height in pixels
   */
  loaderHeight?: string;
  onClick?: () => void;
  type?: any;
};

export const Button: React.FC<buttonProps> = ({
  label,
  className,
  varient,
  style,
  disabled,
  size,
  icon,
  withIcon,
  isLoading,
  loaderColor,
  loaderWidth,
  loaderHeight,
  onClick,
  type,
}) => {
  return (
    <button
      className={`btn ${varient === "primary" && "btn-primary"} ${varient === "secondary" && "btn-secondary"} ${
        varient === "tertiary" && "btn-tertiary"
      } ${size === "small" && "btn-small"} ${className}`}
      style={style}
      disabled={!!disabled}
      onClick={onClick}
      type={type}
    >
      {isLoading ? (
        <Spinner color={loaderColor} width={loaderWidth} height={loaderHeight} />
      ) : (
        <>
          {withIcon && <div className="icon">{icon}</div>} {label}
        </>
      )}
    </button>
  );
};

Button.defaultProps = {
  label: "button",
  className: undefined,
  varient: "primary",
  style: undefined,
  disabled: false,
  size: "medium",
  withIcon: false,
  isLoading: false,
  loaderColor: "#FFFFFF",
  loaderWidth: "28px",
  loaderHeight: "28px",
};
